/* Built In Imports */

/* External Imports */
import { Box, VStack } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/HNI/Components/Headings/SectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Services */

/**
 * Renders the ContactUs component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} ContactUs component
 */

const Support = ({ sectionContent, region, lang }) => {
  const title = sectionContent.find(el => el._modelApiKey === 'section_title');
  return (
    <>
      <Box
        background="#FFEBC7"
        textAlign="center"
        p={{ base: '30px 20px 50px ', md: '30px 20px 50px' }}
      >
        <Box>
          <VStack alignItems="center" justifyContent="center">
            <SectionTitle
              className="pricing-title"
              fontSize={{ base: '26px', md: '30px' }}
              titleObj={title}
              maxW={{ base: '295px', md: 'none' }}
            />
          </VStack>
        </Box>

        <Box
          maxW={{ base: '100%', lg: '755px' }}
          m={{ base: '0 auto' }}
          color="#02093C"
          p={{ base: '10px', md: '10px' }}
          // className="shivanga-text contactdetail"
        >
          <Box fontSize={{ base: '16px', md: '18px' }}>
            <StructuredTextParser
              region={region}
              fontSize={{ base: '16px' }}
              lang={lang}
              bgTheme="dark"
              textAlign="center"
              lineHeight="28px"
              str={render(sectionContent?.[1]?.body)}
              sx={{
                strong: {
                  color: '#28231E',
                  fontFamily: 'FedraSansStd-medium',
                  fontWeight: 'normal',
                },
                a: {
                  // color: '#D04723',
                  color: '#cf4824',
                  fontFamily: 'FedraSansStd-book',
                  textDecoration: 'underline',

                  mt: { base: 0, md: '4rem' },
                },
                mark: {
                  color: '#cf4824',
                  cursor: 'pointer',
                  background: 'transparent',
                  fontFamily: 'FedraSansStd-book',
                },
                p: {
                  marginTop: '13px',
                },
              }}
            />
            {/* {StructuredTextContent(sectionContent?.[2]?.body)} */}
          </Box>
        </Box>
      </Box>
      {/* <style global jsx>{`
        .contacttext p {
          padding-bottom: 0 !important;
        }
        .contacttext mark {
          color: #ca4e2a;
        }
        .contactText a {
          color: #ca4e2a;
          text-decoration: underline;
        }
      `}</style> */}
    </>
  );
};

export default Support;
